const initialState = {
    loading: true,
    isLoaded: false,
    isAuthenticated: null,
    isAdmin: null,
    isUser: null,
    isAuthReady: null,
    accessToken: localStorage.getItem("accessToken"),
    refreshToken: localStorage.getItem("refreshToken"),

    user: null,
    userId: null,
    userName: null,
    userEmail: null,
    userPhone: null,
    userType: null,
    userOfficeLevel: null,
    userNid: null,
    userSignature: null,
    isUserNidVerified: null,
    userNidVerificationAttempt: 0,

    profileId: null,
    profileNameEn: null,
    profileNameBn: null,
    profileType: null,
    profileImage: null,

    employeeId: null,
    dealerId: null,
    supervisorId: null,
    designationId: null,
    designationEn: null,
    designationBn: null,
    organogramDesignationId: null,

    organizationId: null,
    workOrganizationId: null,
    organizationNameEn: null,
    organizationNameBn: null,
    organizationIds: [] as any,

    organogramId: null,
    workOrganogramId: null,
    organogramType: null,
    organogramNameEn: null,
    organogramNameBn: null,
    organogramIds: [] as any,

    groupIds: [] as any,
    groupNameList: [] as any,
    groupCodeList: [] as any,

    roleIds: [] as any,
    roleNameList: [] as any,
    roleCodeList: [] as any,

    divisionId: null,
    regionId: null,
    districtId: null,
    thanaId: null,
    unionId: null,
    blockId: null,
    latitude: null,
    longitude: null,

    riceCropId: null,
    currentRiceSeasonId: null,
    currentCropSeasonId: null,
    currentFinancialYearId: null,
    currentFinancialYearTitle: null,
    nextFinancialYearId: null,
    nextFinancialYearTitle: null,
    scopes: [] as any,
    error: null,

    dispatchAuth: (action) => null,
    loadAuthState: (token?) => null,
    clearAuthState: () => null,
    setLoading: (isShow) => null,
};

export default initialState;
